import fetchPersonalisedContentQueryParams from './fetchPersonalisedContentHandler';
import {
  PersonalizedContent,
  PersonalizedContentData
} from '../../../types/consumption';
import { GQL_QUERIES } from '../../../utils/analytics/newrelic/ErrorTracker';
import { FETCH_PERSONALISED_CONTENT_QUERY } from '../../GraphQL/Queries/PersonalisedContentQuery';
import { graphQlRequest } from '../../GraphQL/RequestHandler';

// Type for the parameters
interface PersonalizedContentParams {
  personalizationType: string;
  personalizationMetaData: string;
  sourceType: string;
  contentId: string;
  country: string;
  languages: string;
  translation: string;
}

export const fetchPersonalisedContent = async ({
  personalizationType,
  personalizationMetaData,
  sourceType,
  contentId,
  country,
  languages,
  translation
}: PersonalizedContentParams): Promise<PersonalizedContent> => {
  try {
    const response: PersonalizedContentData = await graphQlRequest(
      FETCH_PERSONALISED_CONTENT_QUERY,
      fetchPersonalisedContentQueryParams(
        personalizationType,
        personalizationMetaData,
        sourceType,
        contentId,
        country,
        languages,
        translation
      ),
      GQL_QUERIES.FETCH_PERSONALISED_CONTENT_QUERY
    );
    return response?.personalizedContent || {};
  } catch (error) {
    console.error('Error while fetching latest movies: ', error);
    return {};
  }
};
